import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { HttpHandler } from '../../api/HttpHandler';
import { environment } from '../../enviroments';
import { changeUserData } from '../../api/user';
import { ISpecialist } from '../specialists/types';
import { Specialist } from '@mindly/ui-components';
import debounce from 'lodash/debounce';

export const fetchFavouriteSpecialists = createAsyncThunk(
  'favouriteSpecialists/fetchFavouriteSpecialists',
  async (_: void, thunkAPI) => {
    const { user } = thunkAPI.getState() as RootState;

    const loadedIds = [...(user?.favourite_specialist_ids ?? [])];
    if (!loadedIds?.length) return [];

    const queryParams = {
      __name__: encodeURIComponent(`in:${JSON.stringify(loadedIds)}`),
    };

    const queryString = Object.keys(queryParams)
      .map((key) => `${key}=${queryParams[key as keyof typeof queryParams]}`)
      .join('&');

    const { data: response } = await HttpHandler({
      method: 'GET',
      url: `${environment.SPECIALIST_URL}/list?${queryString}`,
    });

    return response.data;
  }
);

const debouncedChangeUserData = debounce(changeUserData, 1000);

export const removeSpecialistFromFavourite = createAsyncThunk(
  'favouriteSpecialists/removeSpecialistFromFavourite',
  async (specialist: ISpecialist | Specialist, thunkAPI) => {
    const { user } = thunkAPI.getState() as RootState;

    const favouriteSpecialistsIds = [...(user?.favourite_specialist_ids ?? [])];
    if (!user?.id) return;

    await debouncedChangeUserData({ favourite_specialist_ids: favouriteSpecialistsIds }, user?.id);

    return specialist;
  }
);

export const addSpecialistToFavourite = createAsyncThunk(
  'favouriteSpecialists/addSpecialistToFavourite',
  async (specialist: ISpecialist | Specialist, thunkAPI) => {
    const { user, specialists, favouriteSpecialists, loadedSpecialists } = thunkAPI.getState() as RootState;

    const favouriteSpecialistsIds = [...(user?.favourite_specialist_ids ?? [])];
    if (!user?.id) return;

    await debouncedChangeUserData({ favourite_specialist_ids: favouriteSpecialistsIds }, user?.id);

    return (
      specialists?.listData?.find((el) => el.id === specialist.id) ??
      favouriteSpecialists?.data?.find((el) => el.id === specialist.id) ??
      loadedSpecialists?.data?.find((el) => el.id === specialist.id) ??
      null
    );
  }
);
